import React, { useEffect, useState } from 'react';
import Header from '../layout/Header';
import { getColumns } from './allVoucherColumn';
import AllVoucherPaginated from './AllVoucherPaginated';
import { ValidatorForm } from 'react-form-validator-core';
import SelectValidator from '../partial/SelectValidator';
import { connect } from 'react-redux';
import {
	voucherTemplateDetail,
	clearVoucherTemplate,
} from '../../actions/voucher';
import { getDate, getDisplayDate, getDisplayDateIST, selectValueGetter } from '../../utils/helper';
import {
	RedeemVoucher,
	getVoucherTemplateStatusByCode,
	getVouchersWallet,
	transactionRegistration,
	getVouchercode,
	updateVoucher,
} from '../pages/campaigns/services';
import swal from 'sweetalert';
import { decrypt } from '../../utils/encodingdecoding';
import RemarkModal from './RemarkModal';
import StatusUpdateModal from './StatusUpdateModal';
import { edsringMerchantId, starblazeMerchantId } from '../../utils';
import { Link } from 'react-router-dom';

const getCurrentRecordRemark = (remarksObj) => {
	if (!remarksObj || typeof remarksObj !== 'object') {
		return remarksObj || '';
	}

	const currentRecord =
		remarksObj?.currentRecord ||
		remarksObj?.remarks?.currentRecord ||
		remarksObj?.orderStatus?.currentRecord;

	return currentRecord?.status || currentRecord?.remarks || '';
};

const getOrderRecords = (remarksObj) => {
	if (!remarksObj || typeof remarksObj !== 'object') {
		return [];
	}

	const orderRecord =
		remarksObj?.orderRecord ||
		remarksObj?.remarks?.orderRecord ||
		remarksObj?.orderStatus?.orderRecord ||
		[];

	return [...orderRecord].sort(
		(a, b) => new Date(a.date) - new Date(b.date)
	);
};

// Date on which the "Order Placed" status was recorded for the reward,
// falling back to the "Processing" date when there is no "Order Placed" record
const getOrderPlacedDate = (remarksObj) => {
	const records = getOrderRecords(remarksObj);
	const orderPlaced =
		records.find((record) => record?.status === 'Order Placed') ||
		records.find((record) => record?.status === 'Processing');
	return orderPlaced?.date ? getDisplayDateIST(orderPlaced.date, 'DD-MM-YYYY | hh:mm A') : 'N/A';
};

const AllVouchers = ({
	voucherTemplateDetail,
	VoucherTemplate,
	clearVoucherTemplate,
}) => {
	const [loader, setLoader] = useState(false);
	const [response, setResponse] = useState();
	const [remarks, setRemarks] = useState('');
	const [valueselect, setValueSelect] = useState('all');
	const [option] = useState([
		{ label: 'All Vouchers', value: 'all' },
		{ label: 'Active Vouchers', value: 'Active' },
		{ label: 'Expired Vouchers', value: 'InActive' },
		{ label: 'Redeemed Vouchers', value: 'Redeemed' },
	]);

	const [filterOption, setFilterOption] = useState('all');
	const [data, setData] = useState([]);
	const [remarksModal, setRemarksModal] = useState(false);
	const [selectedVoucher, setSelectedVoucher] = useState({});
	const [templateOptions, setTemplateOptions] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState('all');
	const [statusUpdateModal, setStatusUpdateModal] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState('');

	const isStarblaze =
		decrypt(localStorage.getItem('merchantcode')) === starblazeMerchantId;

	const unPeople = (e) => {
		setValueSelect(e.value);
		setFilterOption(e.value);
	};

	const fetch = async () => {
		setLoader(true);

		const id = decrypt(localStorage.getItem('merchantcode'));
		const token = JSON.parse(localStorage.getItem('token_gen'));

		clearVoucherTemplate();

		try {
			const [voucherRes] = await Promise.all([
				getVouchersWallet(token.access_token, id),
				voucherTemplateDetail(token.access_token),
			]);

			setResponse(voucherRes.data);
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		fetch();
	}, []);

	useEffect(() => {
		const templateDropdown = (VoucherTemplate?.dataList || []).map((item) => ({
			label: item.name,
			value: item.code,
		}));

		setTemplateOptions([
			{ label: 'All Templates', value: 'all' },
			...templateDropdown,
		]);
	}, [VoucherTemplate?.dataList]);
	const onSubmit = () => { };

	const handleVoucher = async (value) => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen'));
		const body = {
			customercode: value?.customerCode,
		};
		let voucherStatusResponse = await getVoucherTemplateStatusByCode(
			token?.access_token,
			body,
		);
		setLoader(false);
	};

	const handleRedeemtion = async (value) => {
		const id = localStorage.getItem('Id');
		setLoader(true);
		let tempToken = JSON.parse(localStorage.getItem('token_gen'));
		tempToken = tempToken?.access_token;
		let currentDate = new Date();
		let formattedDate = getDate(currentDate, 'YYYY/MM/DD');
		let body = {};
		body.customer = {
			customercode: value?.customercode,
		};
		body.redeemDetail = {
			walletType: 'voucher',
			voucherCode: value?.voucherCode,
			transactionType: 'redeem',
			transactionDate: formattedDate,
			VoucherTemplateCode: value?.voucherTemplateCode,
			remarks,
		};
		var temp = {
			customer: {
				customercode: value.customercode,
			},
			transactionDetail: {
				vouchertemplatecode: value?.voucherTemplateCode,
				value: value?.earnedValue,
			},
			schemacode: 'TSC000049',
		};
		await RedeemVoucher(tempToken, body).then((res) => {
			if (res.status === 400) {
				setLoader(false);
				swal({
					position: 'center',
					icon: 'error',
					title: res.message,
					showConfirmButton: false,
					timer: 5000,
				});
			} else {
				handleVoucher(value)
					.then((resp) => {
						setLoader(false);
						swal({
							position: 'center',
							icon: 'success',
							title: 'Voucher Redeemed Successfully',
							showConfirmButton: false,
							timer: 5000,
						});
						value?.voucherType.toLowerCase() == 'discount' &&
							transactionRegistration(
								tempToken,
								JSON.stringify(temp),
							);
					})
					.catch(() => {
						setLoader(false);
					});
				// CustomerWallets(tempToken, { "customercode": value.customercode }).then((res) => {
				//     console.log(res.data)

				// })
			}
		});
		const merchantcode = decrypt(localStorage.getItem('merchantcode'));
		const res = await getVouchersWallet(tempToken, merchantcode, selectedTemplate);
		setResponse(res.data);
		if (decrypt(localStorage.getItem('merchantcode')) === edsringMerchantId) {
			setRemarks("");
			setSelectedVoucher({});
			setRemarksModal(false);
		}
		setLoader(false);
	};

	const handleStatusUpdate = async () => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen'));

		try {
			const res = await getVouchercode(
				token?.access_token,
				selectedVoucher?.customercode,
				selectedVoucher?.voucherCode
			);
			const walletData = res?.data?.[0];
			const voucherId = walletData?.id;

			if (voucherId) {
				const existingOrderRecord = getOrderRecords(walletData?.remarks);
				const newRecord = {
					status: selectedStatus,
					remarks,
					date: new Date().toISOString(),
				};

				const body = {
					name: walletData?.remarks?.name || selectedVoucher?.remarks?.name || '',
					currentRecord: newRecord,
					orderRecord: [...existingOrderRecord, newRecord],
				};

				await updateVoucher(token?.access_token, voucherId, body);

				const merchantcode = decrypt(localStorage.getItem('merchantcode'));
				const voucherRes =
					selectedTemplate === 'all'
						? await getVouchersWallet(token?.access_token, merchantcode)
						: await getVouchersWallet(
							token?.access_token,
							merchantcode,
							selectedTemplate
						);
				setResponse(voucherRes.data);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}

		setStatusUpdateModal(false);
		setSelectedStatus('');
		setRemarks('');
		setSelectedVoucher({});
	};

	useEffect(() => {
		if (response && VoucherTemplate?.dataList) {
			const temp = response.map((voucher) => {
				const matchedVoucher = VoucherTemplate.dataList.find(
					(item) => item.code === voucher.voucherTemplateCode
				);
				const customerLabel = isStarblaze
					? voucher?.remarks?.name || 'N/A'
					: voucher?.customercode;
				return {
					...voucher,
					remarks: getCurrentRecordRemark(voucher.remarks),
					voucherName: matchedVoucher ? matchedVoucher.name : 'N/A',
					customerLabel,
					customerCode:

						<Link
							to={`/customer-view/${voucher?.customercode}`}
							state={{
								customerCode: voucher?.customercode,
							}}
						>
							{`${customerLabel}`}
						</Link>,
					vouchercode: voucher.voucherCode,
					orderDate: isStarblaze ? getOrderPlacedDate(voucher.remarks) : '',
					expiredate: getDisplayDate(voucher.expiryDate, 'DD-MM-YYYY | hh:mm A'),
					assign: voucher.updatedDate
						? getDisplayDate(voucher.updatedDate, 'DD-MM-YYYY | hh:mm A')
						: 'N/A',
					value: voucher.earnedValue,
					action: isStarblaze ? (
						<button
							style={{ textTransform: 'capitalize' }}
							className="badge bg-primary"
							onClick={() => {
								setSelectedVoucher(voucher);
								setSelectedStatus('');
								setRemarks('');
								setStatusUpdateModal(true);
							}}
						>
							Update Status
						</button>
					) : (
						<button
							style={{ textTransform: 'capitalize' }}
							className={
								voucher.voucherUsed
									? 'badge bg-warning'
									: 'badge bg-success'
							}
							onClick={() => {
								if (
									decrypt(localStorage.getItem('merchantcode')) ===
									edsringMerchantId
								) {
									setSelectedVoucher(voucher);
									setRemarksModal(true);
								} else {
									handleRedeemtion(voucher);
								}
							}}
							disabled={voucher?.voucherUsed}
						>
							{voucher?.voucherUsed ? 'redeemed' : 'redeem'}
						</button>
					),
				};
			});

			const currentDate = new Date();
			const filteredData = temp?.filter((val) => {
				let statusMatch = true;

				if (filterOption === 'Redeemed') {
					statusMatch = val.voucherUsed === true;
				} else if (filterOption === 'InActive') {
					statusMatch = new Date(val.expiryDate) < currentDate;
				} else if (filterOption === 'Active') {
					statusMatch = val.voucherUsed === false;
				}

				return statusMatch;
			});

			setData(filteredData.reverse());
		}
	}, [filterOption, response, VoucherTemplate]);

	const downloadCSV = () => {
		if (!data || data.length === 0) {
			swal({
				icon: 'warning',
				title: 'No data to download',
			});
			return;
		}

		const headers = [
			isStarblaze ? 'Reward Name' : 'Voucher Name',
			isStarblaze ? 'Reward Code' : 'Voucher Code',
			isStarblaze ? 'Customer Name' : 'Customer Code',
			'Value',
			'Expiry Date',
			'Assign Date',
			'Status',
		];

		const rows = data.map((item) => [
			item.voucherName,
			item.vouchercode,
			item.customerLabel,
			item.value,
			item.expiredate,
			item.updatedDate,
			item.voucherUsed ? 'Redeemed' : 'Active',
		]);

		const csvContent =
			[headers, ...rows]
				.map((row) => row.map((val) => `"${val}"`).join(','))
				.join('\n');

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'voucher_list.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleTemplateChange = async (e) => {
		const value = e.value;
		setSelectedTemplate(value);

		const token = JSON.parse(localStorage.getItem('token_gen'));
		const merchantcode = decrypt(localStorage.getItem('merchantcode'));

		setLoader(true);

		try {
			let res;
			const body = {}
			if (value === 'all') {
				res = await getVouchersWallet(token.access_token, merchantcode)
			} else {
				res = await getVouchersWallet(token.access_token, merchantcode, value)
			}
			if (res.message === "Success") {
				setResponse(res.data);
			} else {
				setResponse([]);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			<Header name={isStarblaze ? 'Rewards' : 'Vouchers'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					<div className='dashboard__transactionsCard'>
						<div className='dashboard__header'>
							<div className='dashboard__left'>
								<h4 id='transction_list'>{isStarblaze ? 'All Rewards List' : 'All Vouchers List'}</h4>
							</div>
							<div className="dashboard__right">
								<button onClick={downloadCSV} className="btn btn-default">
									<i
										class="fa-solid fa-download"
										style={{ marginRight: "10px" }}
									></i>
									{isStarblaze ? 'Download Reward' : 'Download Voucher'}
								</button>
							</div>
						</div>
						<div className="dashboard__body">
							{!isStarblaze && (
								<div
									className="dashboard__heading"
									style={{ justifyContent: 'end', marginBottom: '0' }}
								>
									<div className="dashboard__headingRight">

										<ValidatorForm onSubmit={onSubmit}>

											<div className="d-flex align-items-center gap-2">
												<div style={{ minWidth: '180px' }}>
													<SelectValidator
														placeholder="Template"
														name="template"
														value={selectValueGetter(templateOptions, selectedTemplate)}
														options={templateOptions}
														onChange={handleTemplateChange}
													/>
												</div>
												<div style={{ minWidth: '200px' }}>
													<SelectValidator
														placeholder="Status"
														name="status"
														value={selectValueGetter(option, valueselect)}
														options={option}
														onChange={unPeople}
													/>
												</div>
											</div>

										</ValidatorForm>
									</div>
								</div>
							)}

							<AllVoucherPaginated
								data={data}
								columns={getColumns()}
								loader={loader}
								setLoader={setLoader}
							/>
						</div>
					</div>
				</div>
			</div>

			{decrypt(localStorage.getItem('merchantcode')) === edsringMerchantId ? (
				<RemarkModal
					isOpen={remarksModal}
					onSubmit={() => handleRedeemtion(selectedVoucher)}
					onChange={(e) => {
						setRemarks(e.target.value);
					}}
					value={remarks}
					onClose={() => {
						setRemarks("")
						setRemarksModal(false);
					}}
				/>
			) : (
				<></>
			)}

			{isStarblaze && (
				<StatusUpdateModal
					isOpen={statusUpdateModal}
					status={selectedStatus}
					onStatusChange={(e) => setSelectedStatus(e.target.value)}
					remark={remarks}
					onRemarkChange={(e) => setRemarks(e.target.value)}
					onSubmit={handleStatusUpdate}
					orderRecords={getOrderRecords(selectedVoucher?.remarks)}
					currentStatus={getCurrentRecordRemark(selectedVoucher?.remarks)}
					onClose={() => {
						setStatusUpdateModal(false);
						setSelectedStatus('');
						setRemarks('');
						setSelectedVoucher({});
					}}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	VoucherTemplate: state.VoucherTemplate,
});
const mapDispatchToProps = {
	voucherTemplateDetail,
	clearVoucherTemplate,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllVouchers);
